'use client'

import { useEffect } from 'react'

type Props = {
  id: string
}

export const ClickRank = ({ id }: Props) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = `https://js.clickrank.ai/seo/${id}/script?${new Date().getTime()}`
    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [id])

  return null
}
